"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OrderDispatchContext = exports.OrderStateContext = exports.initialState = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var initialState = {
  emailAddress: '',
  factura: undefined,
  firstName: '',
  futureOrderTime: undefined,
  isGuest: false,
  lastName: '',
  locationNumber: null,
  orderId: 0,
  paymentInfo: undefined,
  paymentToken: '',
  phoneNumber: '',
  serviceMethod: 0,
  storeId: null,
  tipAmountValue: undefined,
  tipPercentage: undefined,
  walletType: undefined
};
exports.initialState = initialState;

var OrderStateContext = _react["default"].createContext(undefined);

exports.OrderStateContext = OrderStateContext;

var OrderDispatchContext = _react["default"].createContext(undefined);

exports.OrderDispatchContext = OrderDispatchContext;